import { queryInvestorPools } from 'store/reducers-investors/Pools/query'

export const reducersInvestors = {
  [queryInvestorPools.reducerPath]: queryInvestorPools.reducer,
}

export type ReducersInvestors = typeof reducersInvestors

export const middlewareInvestors = [queryInvestorPools.middleware]

export type MiddlewareInvestors = typeof middlewareInvestors
